module.exports = __webpack_public_path__ + "static/media/no_of_one_logo.63d121f7.png";